// Non-survey page behavior. Kept vanilla; no React.
// - Adds `.scrolled` to the top nav once the user scrolls past the top.
// - Toggles the mobile sticky CTA visibility once the hero scrolls out.
// - Drives the mobile hamburger menu (toggle, close on link/outside/Escape).
// - Fires `SignupCTAClick` (once per page load) on any signup anchor click.

function setupCtaTracking(): void {
  // Delegated listener: any anchor that scrolls to the signup form counts as
  // a CTA click. Dedupe per page load so impatient double-clicks don't inflate
  // the funnel count. Meta unique-users dedupe handles cross-session.
  let fired = false;
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement | null;
    if (!target?.closest('a[href="#waitlist"]')) return;
    if (fired) return;
    fired = true;
    window.fbq?.("trackCustom", "SignupCTAClick");
  });
}

function setup(): void {
  const nav = document.getElementById("nav");
  const mobileCta = document.getElementById("mobile-cta");
  const hero = document.querySelector<HTMLElement>(".hero");
  if (!nav || !mobileCta || !hero) return;

  const threshold = (): number => hero.offsetHeight * 0.7;

  const onScroll = (): void => {
    const y = window.scrollY;
    nav.classList.toggle("scrolled", y > 8);
    mobileCta.classList.toggle("visible", y > threshold());
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Mobile hamburger menu.
  const toggle = document.getElementById("nav-toggle");
  const menu = document.getElementById("nav-menu");
  if (toggle && menu) {
    const setOpen = (open: boolean): void => {
      nav.classList.toggle("open", open);
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    };

    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      setOpen(!nav.classList.contains("open"));
    });

    // Close when any menu link is tapped.
    menu.addEventListener("click", (e) => {
      if ((e.target as HTMLElement).closest("a")) setOpen(false);
    });

    // Close on outside click.
    document.addEventListener("click", (e) => {
      if (!nav.classList.contains("open")) return;
      if (!nav.contains(e.target as Node)) setOpen(false);
    });

    // Close on Escape.
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && nav.classList.contains("open")) setOpen(false);
    });
  }
}

function bootstrap(): void {
  setup();
  setupCtaTracking();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  bootstrap();
}
